import OpenCC from '../vendor/opencc'

export const toTraditional = OpenCC.Converter({ from: 'cn', to: 'tw' })
const ignored = 'script,style,noscript,input,textarea,[contenteditable="true"],[data-preserve-text]'
const attributes = ['placeholder', 'title', 'aria-label', 'alt']

export function installTraditionalRendering(root = document.body) {
  document.documentElement.lang = 'zh-Hant'
  function convert(node) {
    if (node.nodeType === 3) {
      if (!node.parentElement || node.parentElement.closest(ignored)) return
      const converted = toTraditional(node.nodeValue)
      if (converted !== node.nodeValue) node.nodeValue = converted
      return
    }
    if (node.nodeType !== 1 || node.matches('script,style,noscript,[contenteditable="true"],[data-preserve-text]')) return
    attributes.forEach(attribute => {
      const original = node.getAttribute(attribute)
      if (original) {
        const converted = toTraditional(original)
        if (converted !== original) node.setAttribute(attribute, converted)
      }
    })
    if (!node.matches('input,textarea')) Array.from(node.childNodes).forEach(convert)
  }
  convert(root)
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(convert)
      else convert(record.target)
    })
  })
  observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes })
  return () => observer.disconnect()
}
